"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagStore = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var timsort_1 = require("timsort");
var services_1 = require("../services");
function tagSort(summaryA, summaryB) {
    if (summaryA.updatedAt < summaryB.updatedAt) {
        return 1;
    }
    else if (summaryA.updatedAt > summaryB.updatedAt) {
        return -1;
    }
    return 0;
}
var TagStore = /** @class */ (function () {
    function TagStore() {
        this.lastFetch = null;
    }
    Object.defineProperty(TagStore.prototype, "fetched", {
        get: function () {
            var rest = services_1.Services.Department.rest;
            return rest.tags.hasFetched;
        },
        enumerable: false,
        configurable: true
    });
    TagStore.prototype.fetch = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.tags.fetch()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.get(id)];
                }
            });
        });
    };
    TagStore.prototype.get = function (id) {
        if (id == null) {
            return null;
        }
        var rest = services_1.Services.Department.rest;
        if (this.lastFetch == null || (this.lastFetch + TagStore.FETCH_TIME) < Date.now()) {
            this.refresh();
        }
        var tag = rest.tags.find('objectId', id);
        // Old tags have different 'objectId' and 'uuid' values
        if (tag == null) {
            tag = rest.tags.find('uuid', id);
        }
        return tag;
    };
    Object.defineProperty(TagStore.prototype, "all", {
        get: function () {
            if (services_1.Services.Department.current == null) {
                return null;
            }
            var tags = services_1.Services.Department.rest.tags.value;
            if (tags == null) {
                return [];
            }
            (0, timsort_1.sort)(tags, tagSort);
            return tags;
        },
        enumerable: false,
        configurable: true
    });
    TagStore.prototype.refresh = function () {
        this.lastFetch = Date.now();
        return services_1.Services.Department.rest.tags.refetch();
    };
    TagStore.FETCH_TIME = 60 * 1000;
    tslib_1.__decorate([
        mobx_1.computed
    ], TagStore.prototype, "all", null);
    return TagStore;
}());
exports.TagStore = TagStore;
//# sourceMappingURL=tag.store.js.map